module.exports = __webpack_public_path__ + "img/title.7c6b0972.png";